import { connect } from "react-redux";
import State from "../../app/state";
import {
  Properties,
  ResultDetailCard,
} from "../../components/ResultDetailCard";

interface OwnProps {
  sectionId?: string;
}

const mapStateToProps = (state: State, ownProps: OwnProps): Properties => {
  let section = state.sectionResults[ownProps.sectionId || ""];
  if (!section)
    return {
      description: "Questions Correct",
      value: `${state.overallResults.questionsCorrect} of ${state.overallResults.totalQuestions}`,
    };

  return {
    description: "Questions Correct",
    value: `${section.questionsCorrect} of ${section.totalQuestions}`,
  };
};

export default connect(mapStateToProps)(ResultDetailCard);
